export default __webpack_public_path__ + "static/lunar-celebrations-2019-lanterns-fc42f6f8077711ae7005ac5eb1dfc58c.jpg";